import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p424224016410185728',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
